import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from '../components/action-window-styles';
import voidItemImage from '../media/void_item.svg';

const ActionWindowItemVoidLine: React.FC<Props> = (props: Props): JSX.Element => {
  const { voidQuantity } = props;
  const classes = styles({});
  const { t } = useTranslation();

  return (
    <Grid container className={`fullWidth`} justifyContent='space-between'>
      <Grid container className={classes.ItemDescriptionHeight}>
        <Grid
          container
          justifyContent='space-between'
          className={`fullWidth${classes.ItemDescriptionPadding}`}
        >
          <Grid item xs={6} container alignItems='center'>
            <Grid item>
              <img src={voidItemImage} alt='ItemVoided' />
            </Grid>
            <Grid
              item
              className={classes.itemVoidedLabel}
              data-testid='action-window-void-item-text'
            >
              {voidQuantity && voidQuantity > 1
                ? t('ActionWindowItemsVoided')
                : t('ActionWindowItemVoided')}
            </Grid>
          </Grid>
          <Grid
            item
            className={classes.itemVoided}
            data-testid='action-window-item-voided-text-quantity'
          >
            <span className={`${classes.autoLeftMargin} ${classes.itemVoidedText}`}>
              <span className={classes.voidedCount}>{voidQuantity}</span>
            </span>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface Props {
  isKeypadVisible: boolean | undefined;
  toggleKeypad: () => void;
  voidQuantity?: number;
}

export default ActionWindowItemVoidLine;
